import type Ably from 'ably';
import React from 'react';
const ABLY_REALTIME_HOST = process.env.NEXT_PUBLIC_ABLY_REALTIME_HOST as string;
const ABLY_FALLBACKS = process.env.NEXT_PUBLIC_ABLY_FALLBACKS as string;

interface AblyConfigProps {
  clientId: NonNullable<Ably.ClientOptions['clientId']>;
  authCallback: NonNullable<Ably.ClientOptions['authCallback']>;
}

export const useAblyConfig = ({
  clientId,
  authCallback,
}: AblyConfigProps): Ably.ClientOptions => {
  return React.useMemo(
    () => ({
      clientId,
      authCallback,
      restHost: ABLY_REALTIME_HOST,
      realtimeHost: ABLY_REALTIME_HOST,
      fallbackHosts: ABLY_FALLBACKS?.split(','),
    }),
    [authCallback, clientId],
  );
};
